module.exports = __webpack_public_path__ + "img/img-banner_2.3425d2df.png";